import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { Raffle } from './raffle'
import { raffleActions } from './raffle.actions'
import * as fromRaffle from './raffle.reducer'
import { RaffleService } from './raffle.service'
import {
  concatMap,
  map,
  switchMap,
  take,
  tap,
  withLatestFrom
} from 'rxjs/operators'
import { raffleSelectors } from '../raffle/raffle.selectors'
import { persistentUserRoleActions } from '../role/user-role/persistent-user-role/persistent-user-role.actions'
import { of } from 'rxjs'
import { persistentUserRoleSelectors } from '../role/user-role/persistent-user-role/persistent-user-role.selector'

@Injectable()
export class RaffleEffects extends ResourceEffects<Raffle> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public raffleService: RaffleService
  ) {
    super(fromRaffle.FEATURE_NAME, raffleService, raffleActions, actions$)
  }

  createOneSubscriptionLink = createEffect(() =>
    this.actions$.pipe(
      ofType(raffleActions.createOneSubscriptionLink),
      concatMap((action) =>
        this.raffleService
          .createOneSubscriptionLink(action.raffleId, action.subscriptionId)
          .pipe(
            withLatestFrom(
              this.store.select(raffleSelectors.selectById, action.raffleId)
            ),
            map(([response, raffle]) =>
              raffleActions.upsertOne({
                entity: {
                  ...raffle,
                  linkedSubscriptions: [
                    ...(raffle.linkedSubscriptions ?? []),
                    action.subscriptionId
                  ]
                }
              })
            )
          )
      )
    )
  )

  deleteOneSubscriptionLink = createEffect(() =>
    this.actions$.pipe(
      ofType(raffleActions.deleteOneSubscriptionLink),
      concatMap((action) =>
        this.raffleService
          .deleteOneSubscriptionLink(action.raffleId, action.subscriptionId)
          .pipe(
            withLatestFrom(
              this.store.select(raffleSelectors.selectById, action.raffleId)
            ),
            map(([response, raffle]) =>
              raffleActions.upsertOne({
                entity: {
                  ...raffle,
                  linkedSubscriptions: raffle.linkedSubscriptions?.length
                    ? [
                        ...raffle.linkedSubscriptions.filter(
                          (subscriptionId) =>
                            subscriptionId !== action.subscriptionId
                        )
                      ]
                    : []
                }
              })
            )
          )
      )
    )
  )

  onSetSelectedUserRole = createEffect(
    () =>
      this.actions$.pipe(
        ofType(persistentUserRoleActions.setSelectedUserRole),
        tap((action) => {
          let userRole:any
          this.store.select(persistentUserRoleSelectors.selectSelectedUserRole).pipe(
            take(1)
            ).subscribe((user)=>{
              userRole=user
            })
            userRole&&this.store.dispatch(raffleActions.resetState())})
      ),
    { dispatch: false }
  )
}
